"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("../styles");
var utils_1 = require("../utils");
var TGCPreviewHeader = function (_a) {
    var headerImage = _a.headerImage, longTitle = _a.longTitle, subtitle = _a.subtitle, children = _a.children;
    var headerImageStyle = (0, react_1.useMemo)(function () { return (__assign(__assign({}, (headerImage ? {
        background: "url(".concat((0, utils_1.assetIdToBytesUrl)(headerImage), ")"),
        backgroundSize: "cover",
    } : {})), styles_1.pageAndStationStyles.headerBackground)); }, [headerImage]);
    return react_1.default.createElement("header", { className: "tgc-preview--header", style: styles_1.pageAndStationStyles.header },
        react_1.default.createElement("div", { style: headerImageStyle },
            react_1.default.createElement("span", { style: styles_1.pageAndStationStyles.headerTitle }, longTitle),
            subtitle ? react_1.default.createElement("span", { style: styles_1.pageAndStationStyles.subtitle }, subtitle) : null,
            children));
};
exports.default = TGCPreviewHeader;
